import { Form, FormApi, FormProps } from "@/components/form";
import { localNow } from "@/shared/local-now";
import { z } from "zod/v4";
import ArticuloTransferenciaGeneralInfoFields from "./_shared/articulo-transferencia-general-info-fields";
import ArticuloTransferenciaArticuloSearch from "./_shared/articulo-transferencia-articulo-search";
import { Stack, Grid2 as Grid } from "@mui/material";
import ArticuloTransferenciaArticuloList from "./_shared/articulo-transferencia-articulo-list";

export const articuloTransferenciaFormSchema = z.object({
    fecha: z.iso.datetime({ local: true, message: "Este campo es requerido" }).default(localNow()),
    tipo: z.number({ message: "Este campo es requerido" }),
    items: z.array(z.object({
        articuloId: z.string().nonempty("Este campo es requerido"),
        cantidad: z.number().min(1, "La cantidad debe ser mayor que 0"),
    })).min(1, "Debe haber por lo menos un ítem")
})

interface ArticuloTransferenciaFormProps extends FormProps<z.input<typeof articuloTransferenciaFormSchema>> {
    onCancel?: (form: FormApi) => void
}

export default function ArticuloTransferenciaForm({
    form,
    onCancel,
    ...props
}: ArticuloTransferenciaFormProps) {
    return <Form form={form} gap={3} {...props}>
        <ArticuloTransferenciaGeneralInfoFields />
        <Grid container columns={{ xs: 1, md: 3 }} spacing={5} flex={1}>
            <Grid component={Stack} size={1}>
                <ArticuloTransferenciaArticuloSearch
                    onArticuloSelect={value => form.pushFieldValue("items", {
                        articuloId: value.articulo.id,
                        articulo: value.articulo,
                        cantidad: value.cantidad
                    } as any)}
                />
            </Grid>
            <Grid component={Stack} size={2} gap={3}>
                <form.Field name="items" mode="array">
                    {field => <ArticuloTransferenciaArticuloList
                        items={field.state.value}
                        remove={field.removeValue}
                    />}
                </form.Field>
                <Stack direction={"row"} justifyContent={"end"} gap={3}>
                    <Form.Button onClick={() => onCancel && onCancel(form)}>Cancelar</Form.Button>
                    <Form.SubmitButton>Guardar</Form.SubmitButton>
                </Stack>
            </Grid>
        </Grid>
    </Form>
}